import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isInArrayPipe'
})
export class IsInArrayPipe implements PipeTransform {

  public transform(value: string, valueArray: string[]): boolean {
    let result: boolean = true;
    if (valueArray.includes(value)) {
      result = false;
    }
    valueArray.push(
        value
    );
    return result;
  }
}

